import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { OptionService } from '../option.service';
import { DirectCharge } from './directCharge.model';
import { DirectChargeService } from './direct-charge.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Clipboard } from '@angular/cdk/clipboard';
import { ExportexcelService } from 'src/app/reports/exportexcel.service';

@Component({
  selector: 'app-direct-charge-orders',
  templateUrl: './direct-charge-orders.component.html',
  styleUrls: ['./direct-charge-orders.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalView"),
    contentRef2: new ViewChild("ModalViewImg"),
    contentRef3: new ViewChild("ModalConfirmReject")
  },
})
export class DirectChargeOrdersComponent implements OnInit {

  directChargeList: DirectCharge[] = [];
  displayedColumns: string[] = ['orderId', 'date', 'userFullName', 'product', 'quantity', 'playerId','playerName',
    'notes', 'imageUrl', 'action'];
  dataSource!: MatTableDataSource<DirectCharge>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false;
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  directCharge: DirectCharge = {} as DirectCharge;

  chargedStatus: { id: number, name: string }[] = [{ id: -1, name: "all" }, { id: 1, name: "chargedDone" },
  { id: 0, name: "notCharged" }, { id: 2, name: "rejected" }];
  selectedStatus: number = 0;


  imgView!: string;
  rejectReason: string = "";
  id: any;
  pageSize = 100;
  userLogin!: string;

  constructor(private service: DirectChargeService,
    private snackBar: MatSnackBar,
    private globle: Globle,
    private localStorage: LocalStorageService,
    private clipboard: Clipboard,
    private excelService: ExportexcelService,
    private dialog: MatDialog) { }

  ngOnInit() {
    // this.displayedColumns = ['orderId', 'date', 'userFullName', 'product', 'playerId', 'notes', 'imageUrl', 'view', 'updateStatus', "reject", "delete"];
    this.pageSize = this.globle.pageSize;
    this.userLogin = this.localStorage.retrieve("userInfo").userId
    this.getDirectCharge();

    setInterval(() => { this.getDirectCharge(); }, 180000);

  }

  getDirectCharge() {
    this.spinnerOverlay = true;
    console.log(this.userLogin)

    this.service.get(this.selectedStatus, this.userLogin).subscribe(data => {

      this.directChargeList = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.directChargeList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  edit(item: any) {
    // this.message_text = item.message;
    this.openDialogView();
  }

  // onDelete(id: number) {
  //   this.message.id = id;
  //   this.openDialog();
  // }

  // delete() {
  //   this.spinnerOverlay = true;
  //   this.dialog.closeAll();
  //   this.service.deleteMessages(this.message.id).subscribe(data => {
  //     this.openSnackBar("Deleted successfully", 'snackBarSuccess');
  //     this.spinnerOverlay = false;
  //     this.getMessages();
  //   },
  //     error => {
  //       console.log(error);
  //       this.spinnerOverlay = false;
  //       this.dialog.closeAll();
  //       if (error.error.message) {
  //         this.openSnackBar(error.error.message, "snackBarError");
  //       }
  //       else {
  //         this.openSnackBar("Internal server error", "snackBarError");
  //       }
  //     })
  // }

  // confirmDelete() {
  //   this.delete();
  // }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogView(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '500px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  viewImg(img: any) {
    this.imgView = img;
    this.openDialogImg();

  }

  openDialogImg(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '1000px',
      height: '1000px'
    });
  }

  openDialogReject(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '250px',
      height: '250px'
    });
  }

  onChargedDone(id: number) {
    this.spinnerOverlay = true;

    var obj = {
      id: id,
      status: 1,
      rejectReason: "",
      compleateBy: this.userLogin
    }
    this.service.updateStatus(obj).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getDirectCharge();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })

  }

  onReject(id: number) {
    this.id = id;
    this.openDialogReject();
  }

  confirmReject() {
    this.spinnerOverlay = true;

    var obj = {
      id: this.id,
      status: 2,
      rejectReason: this.rejectReason,
      compleateBy: this.userLogin
    }

    this.service.updateStatus(obj).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getDirectCharge();
      this.dialog.closeAll();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })
  }

  openSnackBarCopy(playerId: string) {
    this.snackBar.open("تم نسخ  " + playerId, 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: "snackBarSuccess"
    });
  }

  copyPlayerId(playerId: string) {
    this.clipboard.copy(playerId);
    this.openSnackBarCopy(playerId);
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.directChargeList.length; i++) {

      var obj = {
        "رقم الطلب": this.directChargeList[i].orderId,
        "التاريخ": this.directChargeList[i].dateTime,
        "اسم المستخدم": this.directChargeList[i].userFullName,
        "المنتج ": this.directChargeList[i].product,
        "الكمية": this.directChargeList[i].quantity,
        "رقم المعرف": this.directChargeList[i].playerId,
        "ملاحظات": this.directChargeList[i].notes,
      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, '  طلبات الشحن المباشر');
  }
}
